import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/ImportEstimationTree/ImportEstimationTree.tsx";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.map.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { MacosExplorer, fromRefs } from '@gmini/ui-kit';
import * as smApi from '@gmini/sm-api-sdk';
import React from 'react';
import { useStore } from 'effector-react';
import * as estApi from '@gmini/sm-api-sdk/lib/EstimationApi';
import { PANEL_WIDTH } from "../../constants";
import { fromTreeData } from "../../../SelectDependencies/EstimationTree/EstimationTree";
import { importEstimationService } from "../../model";
import { ItemPropsCtx } from "../itemPropsCtx";
import { ImportEstimationItemRenderer } from "../ImportEstimationItemRenderer";
import { Backdrop, ProgressBar } from "../../../SelectDependencies/BackDrop";
import { PanelRenderer } from "./PanelRenderer";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImportEstimationTree = function ImportEstimationTree(_ref) {
  var tree$ = _ref.tree$,
      currentUserClassifier$ = _ref.currentUserClassifier$,
      seoEventManager = _ref.seoEventManager,
      estimationId = _ref.estimationId;
  var preloadPending = useStore(importEstimationService.preloadPending$, {
    loc: {
      file: _effectorFileName,
      line: 42,
      column: 25
    },
    name: "ImportEstimationTree",
    sid: "ImportEstimationTree /src/classifier-editor/ImportEstimation/components/ImportEstimationTree/ImportEstimationTree.tsx [42, 25]"
  });
  var repoPending = smApi.UserClassifierRepo.fetch.defaultContext.useCommonPending();
  var estimationRepoTree = useStore(tree$, {
    loc: {
      file: _effectorFileName,
      line: 45,
      column: 29
    },
    name: "ImportEstimationTree",
    sid: "ImportEstimationTree /src/classifier-editor/ImportEstimation/components/ImportEstimationTree/ImportEstimationTree.tsx [45, 29]"
  });
  var currentUserClassifier = useStore(currentUserClassifier$, {
    loc: {
      file: _effectorFileName,
      line: 46,
      column: 32
    },
    name: "ImportEstimationTree",
    sid: "ImportEstimationTree /src/classifier-editor/ImportEstimation/components/ImportEstimationTree/ImportEstimationTree.tsx [46, 32]"
  });
  var activeEstimation = useStore(importEstimationService.activeEstimation$, {
    loc: {
      file: _effectorFileName,
      line: 47,
      column: 27
    },
    name: "ImportEstimationTree",
    sid: "ImportEstimationTree /src/classifier-editor/ImportEstimation/components/ImportEstimationTree/ImportEstimationTree.tsx [47, 27]"
  });
  var projectUrn = currentUserClassifier === null || currentUserClassifier === void 0 ? void 0 : currentUserClassifier.projectUrn;
  React.useEffect(function () {
    if (!projectUrn) {
      return;
    }

    smApi.UserClassifierRepo.fetch.defaultContext.submit({
      projectUrn: projectUrn
    });
    importEstimationService.initTree(projectUrn, tree$).then(function (active) {
      return _setActiveItems(active);
    });
    return function () {
      return importEstimationService.resetPreloadPending();
    };
  }, [projectUrn, tree$]);
  var treeData = estimationRepoTree;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeItems = _React$useState2[0],
      _setActiveItems = _React$useState2[1];

  var d = React.useMemo(function () {
    return fromTreeData(treeData);
  }, [treeData]);
  var setActiveItems = React.useCallback(function (next) {
    _setActiveItems(next);

    var toSaveData = fromRefs(d, next).map(function (_ref2) {
      var _ref2$payload = _ref2.payload,
          id = _ref2$payload.id,
          type = _ref2$payload.type;
      return {
        id: id,
        type: type
      };
    });
    importEstimationService.saveToPersist(toSaveData);
  }, [d]);
  var onClickNode = React.useCallback(function (node) {
    if (node.type === 'EstimationNode') {
      importEstimationService.fetchActiveEstimation({
        id: node.id
      });
    }
  }, []);
  var itemCtxValue = React.useMemo(function () {
    return {
      currentUserClassifier$: currentUserClassifier$,
      onClickNode: onClickNode,
      isSelected: function isSelected(node) {
        return node.id === (activeEstimation === null || activeEstimation === void 0 ? void 0 : activeEstimation.id);
      },
      seoEventManager: seoEventManager,
      activeEstimation: activeEstimation,
      estimationId: estimationId
    };
  }, [currentUserClassifier$, onClickNode, seoEventManager, activeEstimation, estimationId]);
  var pending = preloadPending || repoPending;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Backdrop, {
      open: pending,
      children: /*#__PURE__*/_jsx(ProgressBar, {})
    }), !pending && /*#__PURE__*/_jsx(ItemPropsCtx.Provider, {
      value: itemCtxValue,
      children: /*#__PURE__*/_jsx(MacosExplorer, {
        activeItems: activeItems,
        onChangeActive: setActiveItems,
        ItemRenderer: ImportEstimationItemRenderer,
        treeData: d,
        PanelRender: PanelRenderer,
        fetchChildren: /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
            var payload;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    payload = _ref3.payload;
                    _context.t0 = payload.type;
                    _context.next = _context.t0 === 'EstimationRepoFolderNode' ? 4 : 6;
                    break;

                  case 4:
                    _context.next = 6;
                    return estApi.EstimationRepoFolder.Populated.fetch.defaultContext({
                      id: payload.id
                    });

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }(),
        panelWidth: PANEL_WIDTH
      })
    })]
  });
};